module.exports = __webpack_public_path__ + "static/img/task.0d7e80f.png";